<template>
  <b-modal 
    size="lg"
    hide-footer
    :header-class="displayTabs ? 'pb-0 pl-4' : 'pl-4'"
    @hidden="emitHidePopup"
    v-model="displayPopup">

    <template #modal-title>
      <div class="d-flex align-items-center" v-if="displayTabs">
        <p 
          v-for="tab in tabs" 
          class="mb-0 mr-4 pb-3 border-b-bold border-dark"
          :class="tab.id === activeTab.id ? 'body-1-4 border-dark' : 'body-1 border-white'"
          @click="selectTab(tab)"
          >{{ tab.title }}</p>
      </div>
      <h5 v-else class="body-1-4 mb-0">Currency</h5>
    </template>

    <div v-if="activeTab.id === 'CURRENCY' || !displayTabs" class="w-100 container-fluid overflow-y-auto" style="max-height: 80vh;">
      <div class="row slim-grid-row">
        <div class="col-12 col-md-6 col-lg-4 mb-3"
          v-for="currency in currencyList" @click="changeCurrency(currency)">
          <div class="px-3 py-2 currency" :class="generateWrapperStyle(currency)">
            <div class="w-100 d-flex align-items-center">
              <div class="w-100" :class="{
                'pr-3 overflow-hidden' : selectedCurrency.code === currency.code
              }">
                <p class="mb-0 body-2-1 text-truncate title">{{currency.name}}</p>
                <p class="mb-0 body-2-2-1 subtitle">
                  {{currency.code}} - {{currency.symbol_native}}
                </p>
              </div>
              <div v-if="selectedCurrency.code === currency.code" class="flex-shrink-0" style="opacity: 0.5;">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div class="primary-overlay z-index-1025" v-if="generateWrapperStyle(currency) === 'active' || generateWrapperStyle(currency) === 'active loading'"></div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeTab.id === 'LANGUAGE' && displayTabs" class="w-100 container-fluid overflow-y-auto" style="height: 40vh;">
      <div class="row slim-grid-row">
        <div class="col-12 col-md-6 col-lg-4 mb-3"
          v-for="language in getMerchant.language" @click="changeLanguage(language)">
          <div class="px-3 py-2 currency" :class="generateWrapperStyle(language, 'language')">
            <div class="w-100 d-flex align-items-center">
              <div class="pr-3">
                <img :src="language.image_url" width="50" />
              </div>
              <div class="w-100" :class="{
                'pr-3 overflow-hidden' : selectedLanguage.iso_code === language.iso_code
              }">
                <p class="mb-0 body-2-1 text-truncate title">{{language.name}}</p>
                <p class="mb-0 body-2-2-1 subtitle text-uppercase">
                  {{language.iso_code}}
                </p>
              </div>
              <div v-if="selectedLanguage.iso_code === language.iso_code" class="flex-shrink-0" style="opacity: 0.5;">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
            <div class="primary-overlay z-index-1025" v-if="generateWrapperStyle(language, 'language') === 'active' || generateWrapperStyle(language, 'language') === 'active loading'"></div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import currencyData from "@/data/currency";
  import { mapGetters, mapMutations } from "vuex";
  
  export default {
    props:{
      showPopup:{
        type: Boolean,
        default: false
      }
    },
    data(){
      return{
        changingStatus:{
          isLoad: false,
          error: ''
        },
        selectedCurrency: {},
        displayPopup: false,
        activeTab: {id: 'CURRENCY', title: "Currency"},
        tabs: [{id: 'CURRENCY', title: "Currency"}, {id: 'LANGUAGE', title: "Language"}],
        selectedLanguage: {}
      }
    },
    computed:{
      ...mapGetters(['getCurrency', 'getMerchant', 'getCurrentLanguage']),
      displayTabs(){
        return this.getMerchant.language.length > 1
      },
      currencyList(){
        const { booking_engine_available_currency = [] } = this.getMerchant;
        if(this.$isEmpty(booking_engine_available_currency)) return currencyData;
        let list = []
        for(const currency of booking_engine_available_currency) {
          const constcurrencyItem = currencyData.find(cr => cr.code === currency);
          list.push(constcurrencyItem);
        }
        return list;
      },
    },
    watch:{
      showPopup(){
        this.togglePopup(this.showPopup);
      }
    },
    methods:{
      ...mapMutations(['setCurrency', 'setLanguageMutation']),
      async changeCurrency(currency) {
        try {
          if(this.changingStatus.isLoad) return;
          
          this.selectedCurrency = currency;
          this.changingStatus = { isLoad: true, error: '' }
          
          await this.$convertCurrency(currency.code);
          this.setCurrency(currency)
          window.location.reload();
          
        } catch (error) {
          this.changingStatus.error = error;
        } finally {
          this.changingStatus.isLoad = false;
          this.selectedCurrency = {}
        }
      },
      generateWrapperStyle(data, type="currency"){
        if(this.changingStatus.isLoad){
          if(type === 'currency'){
            return data.code === this.selectedCurrency.code ? 'active loading' : 'loading'
          }else{
            return data.iso_code === this.selectedLanguage.iso_code ? 'active loading' : 'loading'
          }
        }else{
          if(type === 'currency'){
            return data.code === this.getCurrency.code ? 'active' : ''
          }else{
            return data.iso_code === this.getCurrentLanguage ? 'active' : ''
          }
        }
      },
      togglePopup(show = false){
        this.displayPopup = show;
        this.$emit('togglePopup', show);
      },
      emitHidePopup(){
        this.$emit('togglePopup', false)
      },
      selectTab(tab){
        this.activeTab = tab
      },
      async changeLanguage(language) {
        try {
          if(this.changingStatus.isLoad) return;
          
          this.selectedLanguage = language;
          this.changingStatus = { isLoad: true, error: '' }
          this.setLanguageMutation(language)
          window.location.reload();
          
        } catch (error) {
          this.changingStatus.error = error;
        } finally {
          this.changingStatus.isLoad = false;
          this.selectedLanguage = {}
        }
      },
    },
  }
</script>
<style scoped>
  .cur-box:hover{
		background-color: #f2f2f2;
		transition: 0.3s;
	}
	.cur-box-green{
		background-color: #99FF001C;
	}
  .currency{
    border-radius: 4px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    border: 1px solid transparent;
  }
  .currency:not(.active):hover{
    background-color: #f8f9fa;
    border: 1px solid #CCC;
  }
  .currency.active{
    border: 1px solid var(--merchant-primary-color) !important;
  }
  .currency.active.loading{
    opacity: 0.7;
  }
  .currency.loading{
    cursor: wait !important;
  }
  .currency.active .title{
    font-family: Nunito-Bold;
  }
</style>


// WEBPACK FOOTER //
// src/components/general/GeneralLanguageCurrency.vue